<template>
  <div class="zn-page">
    <div class="zn-header">
      <img src="@/assets/images/zn/zn-header.png" alt="" />
      <div>STEAM科创</div>
    </div>
    <div class="zn-container">
      <div class="zn-content">
        <div class="course-introd" v-if="!tabIndex && !znIndex">
          <img src="@/assets/images/zn/steam-page.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AliPlayer from "@/components/AliPlayer";
export default {
  components: {
    AliPlayer,
  },
  data() {
    return {
      navLists: [],
      znIndex: 0,
      tabIndex: 0,
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.zn-page {
  .zn-header {
    height: 0;
    padding-bottom: 32.3%;
    background: url("../../../assets/images/zn/zn-bg.png") no-repeat top center;
    background-size: 100% 100%;
    text-align: center;
    position: relative;
    img {
      width: 449px;
      height: 202px;
    }
    div {
      position: absolute;
      top: 145px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 24px;
      color: #fff;
    }
  }
  .zn-container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 127px;
    left: 50%;
    transform: translateX(-50%);
    top: 202px;
    position: absolute;
  }
  .zn-content {
    background: #fff;
    padding: 42px 0px 110px 0px;
    border-radius: 16px;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);

    .course-introd {
      width: 876px;
      margin: 0 auto;
      margin-top: 20px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
